import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import template from './modules/template';
import auth from './modules/auth';
import app from './modules/app';
import permission from './modules/permission';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        template,
        auth,
        app,
        permission
    },
    mutations: {
        // eslint-disable-next-line no-unused-vars
        CLEAR_AUTH(state) {
            // 重置各模块状态，不直接修改模块 state
        }
    },
    actions: {
        clearAuth({commit}) {
            commit('auth/SET_TOKEN', null);
            commit('auth/SET_USER_INFO', null);
            commit('app/SET_LOGIN_FORM', null);
            commit('app/SET_CURRENT_MENU', null);
            commit('permission/CLEAR_MENU_LIST');
        }
    },
    plugins: [
        createPersistedState({
            key: 'app_data',
            paths: [
                'template.basicList',
                'template.followList',
                'auth.token',
                'auth.userInfo',
                'app.loginForm',
                'app.currentMenu',
                'permission.menuList'
            ],
            storage: window.sessionStorage
        })
    ]
});
